export default __webpack_public_path__ + "static/media/300x600-2b.7118453d.gif";